import React, { useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { Loading } from 'react-lib/dist/components-es';
import { compose } from 'redux';
import { Grid } from 'semantic-ui-react';
import connect from 'react-redux/es/connect/connect';

import { equipmentsActions } from '../../behavior/equipments';
import { fieldKey } from '../../constants';

import LocationContainer from '../Inventory/InventoryDetails/GeneralInformation/ILocationContainer';
import EnvironmentalInformationSelectInputsComponent from '../Inventory/InventoryDetails/EnvironmentalInformation/IEnvironmentalInformationAllSelectInputs';
import ICheckedInformationContainer from '../Inventory/InventoryDetails/CheckedInformation/ICheckedInformationContainer';
import GridColumnInputWrapper from '../common/GridColumnInputWrapper';
import { InputWrapper } from 'react-lib/dist/components-es';
import CommonTagsInputWrapper from '../common/CommonTagsInputWrapper';
import PersonListContainer from '../common/PersonListContainer';
import PersonInList from '../../objects/PersonInList';
import { filterActions } from '../../behavior/filter';
import { batchUpdateActions } from '@behavior/batchUpdate';
import { momentParse } from 'react-lib/dist/dates-es';

const BatchUpdateFieldList = ({
  props,
  initialData,
  selectedFields,
  mandatoryFields,
  equipmentList,
  isLoading,
  isLoadingLocationList,
  isContactOverrideMode,
  actions,
  mode
}) => {
  const usePrevious = value => {
    const ref = useRef();
    useEffect(() => {
      ref.current = Object.keys(value).map(entry => value[entry].key);
    }, [selectedFields.length]);
    return ref.current;
  };
  const prevSelectedFields = usePrevious(selectedFields);

  useEffect(() => {
    let listOfVisibleFields = Object.keys(selectedFields).map(entry => selectedFields[entry].key);
    if (
      (listOfVisibleFields.includes(fieldKey.ENV_ASSET) ||
        listOfVisibleFields.includes(fieldKey.ENV_FUNCTIONAL_POSITION)) &&
      equipmentList.length === 0 &&
      !isLoading
    ) {
      actions.getEquipmentList();
    }
  });

  const getFieldByType = (props, entry) => {
    if (fieldKey.GEN_LOCATION_NAME === entry.value || fieldKey.GEN_EXPERIMENT === entry.value) {
      const locationIsSelected = fieldIsSelected(fieldKey.GEN_LOCATION_NAME);
      const experimentIsSelected = fieldIsSelected(fieldKey.GEN_EXPERIMENT);
      if (locationIsSelected && isNewlySelected(fieldKey.GEN_LOCATION_NAME)) {
        props.values.location = null;
        props.values.outOfBuilding = false;
      }
      if (experimentIsSelected && isNewlySelected(fieldKey.GEN_EXPERIMENT))
        props.values.experiment = null;

      return (
        <LocationContainer
          {...props}
          renderLocationFieldOnly={locationIsSelected}
          renderExperimentFieldOnly={experimentIsSelected}
          initialData={initialData}
          mode={mode}
        />
      );
    } else if (fieldKey.GEN_CONTACTS === entry.value) {
      if (props.values.contacts === undefined || isNewlySelected(entry.value))
        props.values = { contacts: [] };

      return (
        <GridColumnInputWrapper
          {...props}
          value={''}
          name="contacts"
          label="inventory.details.page.contact.list.container.title"
          handleChange={() => {}}
          render={props => (
            <PersonListContainer
              {...props}
              key={entry.value}
              errors={{}}
              newPersonEntity={PersonInList}
              arrayPropName="contacts"
              fieldPropName="person"
              showAddNew={true}
              showDeleteHandler={true}
              isNotMissingLmsCourses={true}
              showOverride
              overridePersonState={isContactOverrideMode}
              setOverridePersonState={actions.setIsContactOverrideMode}
            />
          )}
        />
      );
    } else if (fieldKey.ENV_FUNCTIONAL_POSITION === entry.value) {
      const equipmentCodeIsSelected = fieldIsSelected(fieldKey.ENV_ASSET);
      if (!equipmentCodeIsSelected && isNewlySelected(entry.value) && props.values.asset)
        props.values.asset = null;

      return (
        equipmentList.length > 0 && (
          <GridColumnInputWrapper
            {...props}
            name="asset"
            label="inventory.details.page.equipment.container.asset.position.input"
            render={props => (
              <CommonTagsInputWrapper
                {...props}
                setFieldValue={props.setFieldValue}
                suggestionList={equipmentList}
                matchProperty="position"
                displayProps="position"
                value={props.values.asset}
                maxTags={1}
                onlyUnique={true}
              />
            )}
          />
        )
      );
    } else if (fieldKey.ENV_ASSET === entry.value) {
      const funcPosIsSelected = fieldIsSelected(fieldKey.ENV_FUNCTIONAL_POSITION);
      if (!funcPosIsSelected && isNewlySelected(entry.value) && props.values.asset)
        props.values.asset = null;

      return (
        equipmentList.length > 0 && (
          <GridColumnInputWrapper
            {...props}
            name="asset"
            label="inventory.details.page.equipment.container.asset.input"
            render={props => (
              <CommonTagsInputWrapper
                {...props}
                setFieldValue={props.setFieldValue}
                suggestionList={equipmentList}
                matchProperty="equipmentCode"
                displayProps="equipmentCode"
                value={props.values.asset}
                maxTags={1}
                onlyUnique={true}
              />
            )}
          />
        )
      );
    } else if (fieldKey.GEN_TRADE_NAME === entry.value) {
      if (!props.values.chemicalProduct || isNewlySelected(entry.value))
        props.values.chemicalProduct = {};

      return (
        <GridColumnInputWrapper
          {...props}
          name="chemicalProduct.selectedChemicalProduct"
          label="chemical.product.details.page.chemical.container.search.trade.name.input"
          render={props => (
            <CommonTagsInputWrapper
              {...props}
              value={props.values.chemicalProduct.selectedChemicalProduct}
              dynamicSuggestionListActionWithName={filterActions.getAutoCompleteSuggestionsList.bind(this,true)}
              dynamicSuggestionName="EXCLUDED_GEN_TRADE_CHEMICAL_NAMES"
              matchProperty="id"
              displayProps="tradeName,chemicalName"
              maxTags={1}
              onlyUnique={true}
            />
          )}
        />
      );
    } else if (fieldKey.GEN_QUANTITY === entry.value) {
      if (isNewlySelected(entry.value)) props.values.quantity = null;

      return (
        <GridColumnInputWrapper
          {...props}
          value={''}
          name="quantity"
          label="inventory.details.page.chemical.container.quantity.input"
          type="number"
          onChange={() => {}}
          render={props => <InputWrapper inputLabel={null} inputLabelPosition={null} {...props} />}
        />
      );
    } else if (Object.keys(fieldKey.envAttrs).includes(entry.value)) {
      const { values } = props;
      const envAttributesPropName = 'envAttributes';
      if (!values[envAttributesPropName]) values[envAttributesPropName] = {};
      if (isNewlySelected(entry.value))
        values[envAttributesPropName][fieldKey.envAttrs[entry.value]] = null;

      return (
        <EnvironmentalInformationSelectInputsComponent
          {...props}
          initialData={initialData}
          values={values}
          filter={fieldKey.envAttrs[entry.value]}
        />
      );
    } else if (fieldKey.GEN_IS_CHECK_VALID === entry.value ) {
        props.values.checkUser = initialData.currentUser;
        props.values.checkDte = momentParse(new Date());

        return (
          <ICheckedInformationContainer
            {...props}
            initialData={initialData}
            columns={1}
            checkedMode="mark"
          />
        );
    }
  };

  const fieldIsSelected = field => {
    return selectedFields.map(entry => entry.value).indexOf(field) !== -1;
  };

  const isNewlySelected = field => {
    return !prevSelectedFields.some(r => r == field);
  };

  const filterDuplicateSelectedFields = () => {
    let visibleFields = selectedFields.concat(mandatoryFields);

    const selectedFieldsValues = visibleFields.map(entry => entry.value);
    const checkUserPos = selectedFieldsValues.indexOf(fieldKey.GEN_CHECK_USER);
    const checkDatePos = selectedFieldsValues.indexOf(fieldKey.GEN_CHECK_DATE);
    const bothCheckAtByAreSelected = checkUserPos !== -1 && checkDatePos !== -1;

    const locationPos = selectedFieldsValues.indexOf(fieldKey.GEN_LOCATION_NAME);
    const experimentPos = selectedFieldsValues.indexOf(fieldKey.GEN_EXPERIMENT);
    const bothLocationExperimentAreSelected = locationPos !== -1 && experimentPos !== -1;

    return visibleFields.filter(
      entry =>
        (!bothCheckAtByAreSelected ||
          (bothCheckAtByAreSelected &&
            entry.value !==
              (checkUserPos > checkDatePos ? fieldKey.GEN_CHECK_USER : fieldKey.GEN_CHECK_DATE))) &&
        (!bothLocationExperimentAreSelected ||
          (bothLocationExperimentAreSelected &&
            entry.value !==
              (locationPos > experimentPos ? fieldKey.GEN_LOCATION_NAME : fieldKey.GEN_EXPERIMENT)))
    );
  };

  const generateFields = props => {
    return filterDuplicateSelectedFields().map(entry => {
      return (
        <Grid.Column computer={4} tablet={8} mobile={16} key={entry.value}>
          {getFieldByType(props, entry)}
        </Grid.Column>
      );
    });
  };

  return (
    <div className="batchUpdateFieldList ui form">
      <Loading isLoading={isLoading || isLoadingLocationList} />
      <Grid columns="equal">
        <Grid.Row>{generateFields(props)}</Grid.Row>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  ...state.equipments,
  isLoadingLocationList: state.locations.isLoadingLocationList, 
  isContactOverrideMode: state.batchUpdate.isContactOverrideMode
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getEquipmentList: () => dispatch(equipmentsActions.getEquipmentAutocompleteList()),
    setIsContactOverrideMode: (state)=> dispatch(batchUpdateActions.setIsContactOverrideMode(state))
  }
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(BatchUpdateFieldList);
